import moment from 'moment';
import 'whatwg-fetch';

let uuid;

export const sendLog = function(type = '', msg, data = '') {
    if (typeof msg !== 'string') {
        return Promise.reject('msg must be s string');
    }
    if (!uuid) {
        uuid = guid();
    }
    const dataToSend = {
        clientTimeStamp: moment().format('dddd, MMMM Do YYYY, h:mm:ss a'),
        uuid,
        type,
        msg,
        data
    };

    return fetch('/logFromClient', {
        method: 'post',
        body: JSON.stringify(dataToSend),
        headers: new Headers({
            'Content-Type': 'application/json',
            Accept: 'application/json'
        })
    }).then(res => res.json());
};


function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}

